exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Backdrop_backdrop__PmdBI {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  overflow: auto;\n  z-index: 1000;\n}\n\n.Backdrop_content__2Kmrw {\n  position: relative;\n  z-index: 1001;\n  margin: 32px auto;\n  transform: translate(0, 0);\n}\n\n.Backdrop_layer__3V2YH {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  background: #090015;\n  opacity: 0.85;\n  transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  pointer-events: none;\n  z-index: 1000;\n}", ""]);

// Exports
exports.locals = {
	"backdrop": "Backdrop_backdrop__PmdBI",
	"content": "Backdrop_content__2Kmrw",
	"layer": "Backdrop_layer__3V2YH"
};